import React, { useState } from 'react'
import { Link } from 'gatsby'
import { useKeenSlider } from "keen-slider/react"
import useWindowSize from '../../../lib/hooks'
import styled from 'styled-components'
import Arrow from '../../images/arrow.svg'

const NoSlideContainer = styled.div`
  position: relative;
  background-color: #fff;
  padding-top: 130px;
  padding-bottom: 130px;
  margin-left: auto;
  margin-right: auto;
  img {
    max-width: 100%;
  }
  &.black-white {
    background: linear-gradient(180deg, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 50%, rgba(255,255,255,1) 50%);
  }
`

const NoSlideInner = styled.div`
  max-width: 1192px;
  margin: 0 auto;
  display: flex;
  display: flex;
  column-gap: 60px;
`

const Container = styled.div`
  width: 100%;
  position: relative;
  background-color: #fff;
  padding-top: 130px;
  padding-bottom: 130px;
  @media (max-width: 768px) {
    min-height: 300px;
    width: calc(100vw - 4rem);
    padding-top: 40px;
    padding-bottom: 40px;
  }
  &.grey {
    background-color: #f0f0f0;
    padding-top: 105px;
    padding-bottom: 105px;
  }
  &.black-white {
    background: linear-gradient(180deg, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 50%, rgba(255,255,255,1) 50%);
  }
`

const Slide = styled.div`
  img {
    width: 100%;
    object-fit: cover;
    height: 100%;
    border-radius: 20px;
    aspect-ratio: 4/5;
    @media(max-width: 768px) {
      width: calc(100vw - 2rem);
    }
  }
`

const Text = styled.div`
  border-radius: 20px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: rgba(0,0,0,0.55);
  h3 {
    span {
      font-size: 52px;
      line-height: 72px;
      font-family: Oswald, sans-serif;
      text-transform: uppercase;
      @media(max-width: 768px) {
        font-size: 32px;
        line-height: 32px;
      }
    }
    text-align: center;
  }
`

const Next = styled.img`
  position: absolute;
  z-index: 99;
  right: 0;
  top: calc(50% - 25px);
  width: 50px;
  height: 50px !important;
  right: 16px;
  cursor: pointer;
  transition: opacity 0.25s ease-in-out;
  @media (max-width: 768px) {
    display: none;
  }
  &.disabled {
    opacity: 0;
    pointer-events: none;
  }
`

const Prev = styled.img`
  position: absolute;
  z-index: 99;
  top: calc(50% - 25px);
  width: 50px;
  height: 50px !important;
  left: 16px;
  transform: rotate(180deg);
  transition: opacity 0.25s ease-in-out;
  cursor: pointer;
  @media (max-width: 768px) {
    display: none;
  }
  &.disabled {
    opacity: 0;
    pointer-events: none;
  }
`

const Placeholder = styled.div`
  min-width: calc(((100vw - 1300px)/2) - 30px) !important;
  max-width: calc(((100vw - 1300px)/2) - 30px) !important;
`

const Keen = ({module}) => {

  const { images, background_black_white, background_grey } = module;

  const w = useWindowSize();

  const num_slides = images.length;

  const slides = w && w.width < 768 ? 1.25 : 2.8;

  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false)
  const [sliderRef, instanceRef] = useKeenSlider({
    mode: "snap",
    initial: 0,
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel)
    },
    created() {
      setLoaded(true)
    },
    slides: {
      perView: slides,
      spacing: 30,
    },
  })

  let cn = "keen-slider";

  if (background_black_white) {
    cn = "black-white keen-slider"
  }

  if(background_grey) {
    cn = "grey keen-slider"
  }

  if(num_slides < 3 && w.width > 767) {

    return (
      <NoSlideContainer>
      <NoSlideInner>
      { images.map((image, index) => {

        if(image?.asset?.link) {

        return (
          <Slide key={index} className="keen-slider__slide">
            <Link href={`/${image.asset.link}`}>
              {image.asset.title && <Text><h3>{image.asset.title.split('|').map((t, index) => <span key={index}>{t}<br /></span>)}</h3></Text>}
              <img src={image.asset.publicUrl} />
            </Link>
          </Slide>
        )

        } else {

          return (
            <Slide key={index} className="keen-slider__slide">
              {image.asset.title && <Text><h3>{image.asset.title.split('|').map((t, index) => <span key={index}>{t}<br /></span>)}</h3></Text>}
              <img src={image.asset.publicUrl} />
            </Slide>
          )

        }

      })
      }
      </NoSlideInner>
      </NoSlideContainer>
    )

  } else {

    return (
      <Container ref={sliderRef} className={cn}>
        <Placeholder className="keen-slider__slide">&nbsp;</Placeholder>
        { images.map((image, index) => {

          if(image?.asset?.link) {

          return (
            <Slide key={index} className="keen-slider__slide">
              <Link href={`/${image.asset.link}`}>
                {image.asset.title && <Text><h3>{image.asset.title.split('|').map((t, index) => <span key={index}>{t}<br /></span>)}</h3></Text>}
                <img src={image.asset.publicUrl} />
              </Link>
            </Slide>
          )

          } else {

            return (
              <Slide key={index} className="keen-slider__slide">
                {image.asset.title && <Text><h3>{image.asset.title.split('|').map((t, index) => <span key={index}>{t}<br /></span>)}</h3></Text>}
                <img src={image.asset.publicUrl} />
              </Slide>
            )

          }

        })
        }
        {loaded && instanceRef.current && num_slides > 3 &&
          <>
          <Prev
          src={Arrow}
          onClick={(e) => e.stopPropagation() || instanceRef.current?.prev()}
          disabled={ currentSlide === instanceRef.current.track.details.slides.length - 1}
          className={ currentSlide === 0 ? 'disabled' : 'enabled'}
          />
          <Next
          src={Arrow}
          onClick={(e) => e.stopPropagation() || instanceRef.current?.next()}
          disabled={ currentSlide === instanceRef.current.track.details.slides.length - 1}
          className={ currentSlide === instanceRef.current.track.details.slides.length - 2 ? 'disabled' : 'enabled'}
          />
          </>}
      </Container>
    )

  }
}

export default Keen
